const loadFile = filename => require(`./files/${filename}.json`).ed[`${filename}Table`];

export const equip = loadFile('Equip');

const weapons = {};
const chests = {};
const helmets = {};
const boots = {};
Object.values(equip).forEach(item => {
     const { Quality = 0, Position = 0, Job = ""} = item;
     switch(Position){
      case 1:
        if(weapons[Job] === undefined) weapons[Job] = {};
        weapons[Job][Quality] = item;
        break;
      case 2:
        if(helmets[Job] === undefined) helmets[Job] = {};
        helmets[Job][Quality] = item;
        break;
      case 3:
        if(chests[Job] === undefined) chests[Job] = {};
        chests[Job][Quality] = item;
        break;
      case 4:
        if(boots[Job] === undefined) boots[Job] = {};
        boots[Job][Quality] = item;
        break;
      default:
        break;
     }
});

export const artifactNames = loadFile('Artifact');
export const ARTIFACTS = Object.values(artifactNames);

export const EQUIP_QUALITIES = Object.values(loadFile('EquipQuality'));

export const elderTree = loadFile('Astrolabe');
export const branches = loadFile('AstrolabeTag');
export const branchNames = loadFile('AstrolabeTagSetting');

export const signatures = loadFile('SignatureLevel');
export const heroSignatures = loadFile('Signature');

export const unit = loadFile('Unit');
export const HEROES = Object.values(unit)
  .sort((a, b) => {
    if (a.UnitType === 'Hero' && b.UnitType === 'Hero'){
      if(a.MaxQuality !== b.MaxQuality) return b.MaxQuality - a.MaxQuality;
      return (
        a.DisplayName === ' ' ? `zzzz${a.ID}` : a.DisplayName
      ).localeCompare(
        b.DisplayName === ' ' ? `zzzz${b.ID}` : b.DisplayName
      );
    } else if (a.UnitType === 'Hero'){
      return -1;
    } else if(b.UnitType === 'Hero'){
      return 1;
    } else {
      return (
        a.DisplayName === ' ' ? `zzzz${a.ID}` : a.DisplayName
      ).localeCompare(
        b.DisplayName === ' ' ? `zzzz${b.ID}` : b.DisplayName
      );
    }
  });
export const unitQuality = loadFile('UnitQuality');
export const unitLevel = loadFile('UnitLevel');
export const unitRank = loadFile('UnitRank');

export const unions = loadFile('Troop');

export const artifacts = loadFile('ArtifactRank');

export const getArtifact = (id, level) => artifacts[id] ? artifacts[id][level] || {} : {};

export const getTree = level => elderTree[level] || {};
export const getBranch = (branchId, level) => branches[branchId] ? branches[branchId][level] || {} : {};

export const getHero = id => unit[id] || {};
export const getSignature = (id, level) => signatures[id] ? signatures[id][level] || {} : {};
export const getUnitQuality = (id, quality) => unitQuality[id] ? unitQuality[id][quality] || {} : {};
export const getUnitRank = (id, rank) => unitRank[id] ? unitRank[id][rank] || {} : {};
export const getUnitLevel = level => unitLevel[level] || {};

export const getEquip = id => equip[id] || {};

export const floorAll = obj => {
  Object.keys(obj).forEach(key => obj[key] = Math.floor(obj[key]));
  return obj;
};

export const getUnionCount = (heroId) => Object.values(unions).filter(union => union.HeroIDs.includes(parseInt(heroId))).length;
export const getUnions = (heroId, level) => Object.values(unions)
  .filter(union => union.HeroIDs.includes(parseInt(heroId)))
  .slice(0, level)
  .reduce((final, union) => {
    Object.keys(final).forEach(key => final[key]+=union[key]);
    return final;
  },({
    HP: 0,
    ATK: 0,
    ARM: 0,
    CRIT: 0,
    HIT: 0,
    DODG: 0,
    LFS: 0,
    HPCoef: 0,
    ATKCoef: 0,
    ARMCoef: 0,
  }));


export const getBaseStats = ({ id, quality, level }) => {
  const hero = getHero(id);
  const ascension = getUnitQuality(id, quality);
  const crystal = getUnitLevel(level);
  const rank = getUnitRank(id, crystal.Rank);

  const hpMult = ascension.HP;
  const atkMult = ascension.ATK;
  const defMult = ascension.ARM;
  const hpCoef = hero["+HPCoef"];
  const atkCoef = hero["+ATKCoef"];
  const defCoef = hero["+ARMCoef"];

  let HP = 0;
  let ATK = 0;
  let DEF = 0;
  let CRIT = 0;
  let MSPD = 0;
  let LL = 0;
  let ACC = 0;
  let DODGE = 0;
  let MR = 0;
  let PR = 0;

  HP += hero.HP * hpMult;
  ATK += hero.ATK * atkMult;
  DEF += hero.ARM * defMult;
  CRIT += hero.CRIT;

  HP += ascension.AddHP;
  ATK += ascension.AddATK;
  DEF += ascension.AddARM;

  HP += rank["+HP"]*hpMult;
  ATK += rank["+ATK"]*atkMult;
  DEF += rank["+ARM"]*defMult;
  CRIT += rank["+CRIT"];
  ACC += rank["+HIT"];
  DODGE += rank["+DODG"];
  MSPD += rank["+MSPD"];

  HP += crystal["+HP"]*hpCoef*hpMult;
  ATK += crystal["+ATK"]*atkCoef*atkMult;
  DEF += crystal["+ARM"]*defCoef*defMult;
  CRIT += crystal["+CRIT"];
  ACC += crystal["+HIT"];
  DODGE += crystal["+DODG"];
  MSPD += crystal["+MSPD"];

  return {
    HP,
    ATK,
    DEF,
    CRIT,
    MSPD,
    LL,
    ACC,
    DODGE,
    MR,
    PR,
  }
};

export const computeFinalStats = ({
  heroId = 1,
  ascension = 1,
  crystalLevel = 1,
  treeLevel = 0,
  branchLevel = 0,
  signatureLevel = -1,
  unionLevel = 0,
  artifactId = 0,
  artifactLevel = -1,
  equipment = []
}) => {
  const baseStats = getBaseStats({ id: heroId, quality: ascension, level: crystalLevel });
  const hero = getHero(heroId);
  const tree = getTree(treeLevel);
  const branch = getBranch(hero.AstrolabeTag, branchLevel);
  const signature = getSignature(heroId, signatureLevel);
  const union = getUnions(heroId, unionLevel);
  const artifact = getArtifact(artifactId, artifactLevel);
  const finalStats = { ...baseStats };

  finalStats.HP += tree.HP || 0;
  finalStats.ATK += tree.ATK || 0;
  finalStats.DEF += tree.ARM || 0;

  finalStats.HP += branch.HP || 0;
  finalStats.ATK += branch.ATK || 0;
  finalStats.DEF += branch.ARM || 0;

  finalStats.HP += (baseStats.HP*branch['HP.PR']/100) || 0; 
  finalStats.ATK += (baseStats.ATK*branch['ATK.PR']/100) || 0;
  finalStats.DEF += (baseStats.DEF*branch['ARM.PR']/100) || 0;

  finalStats.CRIT += branch.CRIT || 0;
  finalStats.ACC += branch.HIT || 0;
  finalStats.DODGE += branch.DODG || 0;
  finalStats.MSPD += branch.MSPD || 0;
  finalStats.PR += branch.PIMU || 0;
  finalStats.MR += branch.MIMU || 0;
  finalStats.LL += branch.LFS || 0;

  finalStats.HP += (baseStats.HP * signature['HP.PR']/100) || 0;
  finalStats.ATK += (baseStats.ATK * signature['ATK.PR']/100) || 0;
  finalStats.DEF += (baseStats.DEF * signature['ARM.PR']/100) || 0;
  finalStats.CRIT += signature.CRIT || 0;
  finalStats.ACC += signature.HIT || 0;
  finalStats.DODGE += signature.DODG || 0;
  finalStats.MSPD += signature.MSPD || 0;
  finalStats.PR += signature.PIMU || 0;
  finalStats.MR += signature.MIMU || 0;
  finalStats.LL += signature.LFS || 0;
 
  finalStats.HP += union.HP || 0;
  finalStats.ATK += union.ATK || 0;
  finalStats.DEF += union.ARM || 0;
  finalStats.CRIT += union.CRIT || 0;
  finalStats.ACC += union.HIT || 0;
  finalStats.DODGE += union.DODG || 0;
  finalStats.LL += union.LFS || 0;
  finalStats.HP += (baseStats.HP * union.HPCoef) || 0;
  finalStats.ATK += (baseStats.ATK * union.ATKCoef) || 0;
  finalStats.DEF += (baseStats.DEF * union.ARMCoef) || 0;

  finalStats.HP += (baseStats.HP * artifact['HP.PR']/100) || 0;
  finalStats.ATK += (baseStats.ATK * artifact['ATK.PR']/100) || 0;
  finalStats.DEF += (baseStats.DEF * artifact['ARM.PR']/100) || 0;
  finalStats.CRIT += artifact.CRIT || 0;
  finalStats.ACC += artifact.HIT || 0;
  finalStats.DODGE += artifact.DODG || 0;
  finalStats.MSPD += artifact.MSPD || 0;
  finalStats.PR += artifact.PIMU || 0;
  finalStats.MR += artifact.MIMU || 0;
  finalStats.LL += artifact.LFS || 0;

  equipment.forEach(({ id, level = 0, factionBonus = false }) => {
    const gear = getEquip(id);
    finalStats.HP += gear.HP || 0;
    finalStats.ATK += gear.ATK || 0;
    finalStats.DEF += gear.ARM || 0;
    finalStats.CRIT += gear.CRIT || 0;
    finalStats.DODGE += gear.DODG || 0;
    finalStats.ACC += gear.HIT || 0;
    finalStats.MSPD += gear.MSPD || 0;
    finalStats.PR += gear.PIMU || 0;
    finalStats.MR += gear.MIMU || 0;
    
    finalStats.HP += (level*gear.AddHP) || 0;
    finalStats.ATK += (level*gear.AddATK) || 0;
    finalStats.DEF += (level*gear.AddARM) || 0;
    finalStats.CRIT += (level*gear.AddCRIT) || 0;
    finalStats.DODGE += (level*gear.AddDODG) || 0;
    finalStats.ACC += (level*gear.AddHIT) || 0;
    finalStats.MSPD += (level*gear.AddMSPD) || 0;
    finalStats.PR += (level*gear.AddPIMU) || 0;
    finalStats.MR += (level*gear.AddMIMU) || 0;

    if (factionBonus) {
      finalStats.HP += gear.HP*(gear.TagBonusRate-1) || 0;
      finalStats.ATK += gear.ATK*(gear.TagBonusRate-1) || 0;
      finalStats.DEF += gear.ARM*(gear.TagBonusRate-1) || 0;
      finalStats.CRIT += gear.CRIT*(gear.TagBonusRate-1) || 0;
      finalStats.DODGE += gear.DODG*(gear.TagBonusRate-1) || 0;
      finalStats.ACC += gear.HIT*(gear.TagBonusRate-1) || 0;
      finalStats.MSPD += gear.MSPD*(gear.TagBonusRate-1) || 0;
      finalStats.PR += gear.PIMU*(gear.TagBonusRate-1) || 0;
      finalStats.MR += gear.MIMU*(gear.TagBonusRate-1) || 0;
    }
  });

  return finalStats;
};

export const getBranchName = heroId => {
  const hero = getHero(heroId);
  const tag = hero.AstrolabeTag;
  const branch = branchNames[tag] || {};
  const name = branch.Name || "Dura's Unknown";
  return name.split(" ")[1].toLowerCase();
};

export const getMaxSignature = heroId => {
  const sig = heroSignatures[heroId] || {};
  return sig.MaxLevel || 0;
};

export const getWeapon = (heroId, quality) => {
  const hero = getHero(heroId);
  const job = hero.HeroJob;
  const weaponsForJob = weapons[job] || {};
  return weaponsForJob[quality] || {};
};

export const getHelmet = (heroId, quality) => {
  const hero = getHero(heroId);
  const job = hero.HeroJob;
  const helmetsForJob = helmets[job] || {};
  return helmetsForJob[quality] || {};
};

export const getChest = (heroId, quality) => {
  const hero = getHero(heroId);
  const job = hero.HeroJob;
  const chestsForJob = chests[job] || {};
  return chestsForJob[quality] || {};
};

export const getBoots = (heroId, quality) => {
  const hero = getHero(heroId);
  const job = hero.HeroJob;
  const bootsForJob = boots[job] || {};
  return bootsForJob[quality] || {};
};
